import React, { ButtonHTMLAttributes } from 'react';
import styled from 'styled-components';
import { themeColor } from '../../Theming';
import LoadingIndicator from '../../Common/LoadingIndicator';

const StyledButton = styled.button.attrs(({ type = 'button' }) => ({
  type,
}))<{ height?: string; margin?: string }>`
  background-color: ${themeColor('darkestGrey')};
  color: ${themeColor('white')};
  text-transform: uppercase;
  font-weight: bold;
  border: none;
  padding: 8px;
  font-size: 1rem;
  width: 160px;
  cursor: pointer;
  position: relative;
  height: ${(props) => props.height};
  margin: ${(props) => props.margin};
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &.blueTheme {
    width: 100%;
    text-transform: none;
    border-radius: 6px;
    padding: 12px;
    font-size: 0.875rem;
    max-width: 335px;
    margin-top: 10px;
  }
  &.itvTheme {
    width: 100%;
    font-weight: 400;
    font-family: Arial;
    border-radius: 4px;
    font-size: 14px;
  }
`;

const StyledLoader = styled(LoadingIndicator)`
  transform: scale(0.5) translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: top left;
  & div {
    background: ${themeColor('white')};
  }
`;

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  height?: string;
  margin?: string;
}

const Button: React.FC<ButtonProps> = ({
  loading = false,
  children,
  className,
  height,
  margin,
  ...rest
}) => (
  <StyledButton
    height={height}
    margin={margin}
    className={className}
    disabled={loading}
    {...rest}
  >
    {loading ? (
      <>
        &zwnj;
        <StyledLoader type="spinner" />
      </>
    ) : (
      children
    )}
  </StyledButton>
);

export default Button;

export const WhiteButton = styled(Button)`
  text-transform: none;
  background-color: ${themeColor('white')};
  color: ${themeColor('darkestGrey')};
  border: 1px solid ${themeColor('black')};
  border-radius: 2px;
  width: fit-content;
  padding: 10px 20px;

  :hover {
    border-color: ${themeColor('darkestGrey')};
  }
`;
